import { useState } from 'react';
import { useAdmin } from '../context/AdminContext';

export default function AdminPinModal() {
  const { showPinModal, setShowPinModal, checkPin } = useAdmin();
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (!showPinModal) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const ok = await checkPin(pin);
    setLoading(false);
    if (!ok) {
      setError('Invalid PIN');
      setPin('');
    }
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 p-4"
      onClick={() => {
        setShowPinModal(false);
        setPin('');
        setError('');
      }}
    >
      <div
        className="w-full max-w-sm rounded-xl bg-white p-6 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-lg font-semibold text-gray-900">Admin access</h3>
        <p className="mt-1 text-sm text-gray-500">Enter your PIN</p>
        <form onSubmit={handleSubmit} className="mt-4 space-y-3">
          <input
            type="password"
            inputMode="numeric"
            autoComplete="one-time-code"
            placeholder="PIN"
            value={pin}
            onChange={(e) => {
              setPin(e.target.value);
              setError('');
            }}
            className="w-full rounded-lg border border-gray-300 px-3 py-2 text-center text-lg tracking-widest focus:border-green-500 focus:outline-none focus:ring-1 focus:ring-green-500"
            autoFocus
          />
          {error && <p className="text-sm text-red-600">{error}</p>}
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => {
                setShowPinModal(false);
                setPin('');
                setError('');
              }}
              className="flex-1 rounded-lg border border-gray-300 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading || !pin.trim()}
              className="flex-1 rounded-lg bg-[#112437] py-2 text-sm font-medium text-white hover:bg-[#1a3250] disabled:opacity-50"
            >
              {loading ? 'Checking…' : 'Enter'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
